window.candidates = function (stepName) {

    let step = '';

    const init = function () {
        step = stepName;
        event()
    }

    const event = function () {

        $('#table_' + step).on('click', '.js-add-row, .js-edit-row', function () {
            event.preventDefault;
            // $('#modal_edit').modal('show')
            $('.js-error').fadeOut('fast');
            // let id = $(this).parents('.js-row').length ? $(this).parents('.js-row').data('row-id') : 0;
            let id = $(this).data('row-id') ? $(this).data('row-id') : 0;
            $.get(
                '/candidate/edit',
                {
                    id: id,
                    step: step
                },
                function (result) {
                    if(!!result) {
                        if ($('#modal_edit .modal-body').length === 0) {
                            $('#modal_edit').append('<div class="modal-body"></div>')
                        }
                        $('#modal_edit .modal-body').html(result)
                        $('#modal_edit').modal('show')
                    } else {
                        $('.js-error').text('При получении данных произошла ошибка').fadeIn('fast')
                    }

                }
            )
        })

        $('#table_' + step).on('click', '.js-next-step-sms-row', function () {
            event.preventDefault;
            $('.js-error').fadeOut('fast');
            let id = $(this).data('row-id') ? $(this).data('row-id') : 0;
            $.get(
                '/candidate/sms-template',
                {
                    id: id,
                    step: step
                },
                function (result) {
                    if(!!result) {
                        if ($('#modal_sms .modal-body').length === 0) {
                            $('#modal_sms').append('<div class="modal-body"></div>')
                        }
                        $('#modal_sms .modal-body').html(result);
                        // $('#sms-text').summernote({
                        //     width: '100%',
                        //     height: '128',
                        //     toolbar: [],
                        // });
                        $('#modal_sms').modal('show');
                    } else {
                        $('.js-error').text('При получении данных произошла ошибка').fadeIn('fast')
                    }

                }
            )
        })

        $('#table_' + step).on('click', '.js-next-step-sms-group', function () {
            event.preventDefault;
            $('.js-error').fadeOut('fast');

            let ids = [];
            $('.js-checkbox:checked').each(function (el) {
                ids.push($(this).data('row-id'));
            });
            $.get(
                '/candidate/sms-template',
                {
                    id: ids,
                    step: step
                },
                function (result) {
                    if(!!result) {
                        if ($('#modal_sms .modal-body').length === 0) {
                            $('#modal_sms').append('<div class="modal-body"></div>')
                        }
                        $('#modal_sms .modal-body').html(result);
                        // $('#sms-text').summernote({
                        //     width: '100%',
                        //     height: '128',
                        //     toolbar: [],
                        // });
                        $('#modal_sms').modal('show');
                    } else {
                        $('.js-error').text('При получении данных произошла ошибка').fadeIn('fast')
                    }

                }
            )
        })

        $('#table_' + step).on('click', '.js-save-row', function () {
            $('.js-error').fadeOut('fast');
            $.post(
                '/candidate/save',
                {
                    id: $('[name="id"]').val(),
                    name: $('[name="name"]').val(),
                    last_name: $('[name="last_name"]').val(),
                    phone: $('[name="phone"]').val(),
                    interview_date: $('[name="interview_date"]').val(),
                    diligence: $('[name="diligence"]').val(),
                    interest: $('[name="interest"]').val(),
                    sociability: $('[name="sociability"]').val(),
                    step: step,
                },
                function (result) {
                    if(!!result['id']) {
                        window.location.reload()
                    } else {
                        $('#modal_edit').modal('hide')
                        $('.js-error').text('Произошла непредвиденная ошибка при сохранении').fadeIn('fast')
                    }
                    // $('#modal_edit').modal('hide')
                }
            )
        })

        $('#table_' + step).on('click', '.js-delete-row', function () {
            event.preventDefault;
            $('.js-error').fadeOut('fast');
            if(confirm('Вы действительно хотите удалить данные?')) {
                let id = $(this).data('row-id') ? $(this).data('row-id') : 0;
                $.post(
                    '/candidate/delete',
                    {
                        rowId: id,
                        step: step
                    },
                    function (result) {
                        if(!!result.success) {
                            window.location.reload()
                        } else {
                            $('.js-error').text('Произошла непредвиденная ошибка при удалении').fadeIn('fast')
                        }
                    }
                )
            }
        })

        $('#table_' + step).on('click', '.js-next-step-row', function () {
            $('.js-error').fadeOut('fast');
            if(confirm('Вы действительно хотите перевести кандидата на следующий этап?')) {
                //let id = $(this).parents('.js-row').length ? $(this).parents('.js-row').data('row-id') : 0;
                let id = $(this).data('row-id') ? $(this).data('row-id') : 0;
                $.post(
                    '/candidate/next-step',
                    {
                        id: id,
                        step: step
                    },
                    function (result) {
                        if(!!result.id) {
                            alert('Кандидат успешно переведн в следующий статус');
                            window.location.reload()
                        } else {
                            $('.js-error').text('Произошла непредвиденная ошибка').fadeIn('fast')
                        }
                    }
                )
            }
        })

        $('#table_' + step).on('click', '[data-dismiss="modal"]', function () {
            $('#modal_edit').modal('hide')
            $('#modal_sms').modal('hide')
            // $('#sms-text').summernote('destroy');
        })

        $('#table_' + step).on('click', '.js-next-step-group', function () {
            let ids = [];
            $('.js-checkbox:checked').each(function (el) {
                ids.push($(this).data('row-id'));
            });
            $.post(
                '/candidate/next-step',
                {
                    id: ids,
                    step: step
                },
                function (result) {
                    if(!!result.id) {
                        alert('Кандидаты успешно переведены в следующий статус');
                        window.location.reload()
                    } else {
                        $('.js-error').text('Произошла непредвиденная ошибка').fadeIn('fast')
                    }
                }
            )
        })

        $('input[type="checkbox"]').on('change', function () {
            if($('.js-checkbox:checked').length > 0) {
                $('.js-table-toolbar button').removeClass('disabled').prop('disabled', false)
            } else {
                $('.js-table-toolbar button').addClass('disabled').prop('disabled', true)
            }
        })

        $('#table_' + step).on('click', '.js-send-sms', function () {
            event.preventDefault;
            $('.js-error').fadeOut('fast');
            $.get(
                '/candidate/send-sms',
                {
                    company_id: $('[name="candidate_company_id"]').val(),
                    candidate: $('[name="candidate"]').val(),
                    text: $('[name="sms-text"]').val(),
                    time: $('[name="sms_date"]').val(),
                    isGroup: $('[name="group"]').val(),
                    toNextStep: $('[name="toNextStep"]').val()
                },
                function (result) {
                    if(!!result) {
                        if(!!$('[name="toNextStep"]').val()) {
                            alert('Кандидаты успешно переведены в следующий статус');
                        } else {
                            alert('Смс отправлена');
                        }

                        window.location.reload()
                    } else {
                        $('.js-error').text('При получении данных произошла ошибка').fadeIn('fast')
                    }

                }
            )
        })

        $('#table_' + step).on('click', '.js-sms-row', function () {
            event.preventDefault;
            $('.js-error').fadeOut('fast');
            let id = $(this).data('row-id') ? $(this).data('row-id') : 0;
            $.get(
                '/candidate/sms-template',
                {
                    id: id,
                },
                function (result) {
                    if(!!result) {
                        if ($('#modal_sms .modal-body').length === 0) {
                            $('#modal_sms').append('<div class="modal-body"></div>')
                        }
                        $('#modal_sms .modal-body').html(result);
                        // $('#sms-text').summernote({
                        //     width: '100%',
                        //     height: '128',
                        //     toolbar: [],
                        // });
                        $('#modal_sms').modal('show');
                    } else {
                        $('.js-error').text('При получении данных произошла ошибка').fadeIn('fast')
                    }

                }
            )
        })

    }


    init()
}

